/**
 * Constants for the Footer component
 */

/** Default language fallback */
export const DEFAULT_LANGUAGE = 'de';

/** Prefix for logo alt text */
export const LOGO_ALT_PREFIX = 'Logo';

/** Default focus point for logo images */
export const LOGO_FOCUS_POINT = 'center_left' as const;
